import type { ScenarioDto } from "../../../../contracts";
import { isCommercialPlanData } from "../../../../models/agentResponseModels";
import { isCommercialSimulatorSubBrandToolResponse, isCommercialSimulatorToolResponse } from "../../../../models/toolResponseModels";
import { calculateCommercialPlanMetrics, type CommercialPlanMetrics } from "../../../../utils/commercialPlanCalculations";

export type ScenarioInformation = {
    retailer?: string;
    objective?: string;
    metrics: CommercialPlanMetrics | null;
    key_commercial_decisions: string[];
};

export const getScenarioInformation = (scenario: ScenarioDto | null | undefined): ScenarioInformation => {
    if (!scenario || !scenario?.payload || !isCommercialPlanData(scenario.payload)) {
        return { metrics: null, key_commercial_decisions: [] };
    }

    const metrics = calculateCommercialPlanMetrics(scenario.payload);
    const key_commercial_decisions = scenario.payload.key_commercial_decisions ?? [];

    if (isCommercialSimulatorToolResponse(scenario.input)) {
        return {
            retailer: scenario.input.tool_call_user_selection.retailer_name,
            objective: scenario.input.tool_call.input?.objective,
            metrics: metrics,
            key_commercial_decisions: key_commercial_decisions
        };
    }

    if (isCommercialSimulatorSubBrandToolResponse(scenario.input)) {
        return {
            retailer: scenario.input.tool_call.input?.retailers?.map(retailer => retailer.retailer_name).join(", "),
            objective: scenario.input.tool_call.input?.objective,
            metrics: metrics,
            key_commercial_decisions: key_commercial_decisions
        };
    }

    return { metrics: metrics, key_commercial_decisions: key_commercial_decisions };
};
